import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { useFirestore } from '../../hooks/useFirestore';
import { getClients } from '../../firebase/firestore';
import Section from '../common/Section';
import Loading from '../common/Loading';
import './Clients.css';

const Clients = () => {
    const { t } = useTranslation();
    const { data: clients, loading, error } = useFirestore(useCallback(() => getClients(), []));

    if (loading) {
        return (
            <Section background="gray-light">
                <Loading message={t('common.loading')} />
            </Section>
        );
    }

    if (error || !clients || clients.length === 0) {
        return null; // Don't show section if no clients
    }

    return (
        <Section background="gray-light" id="clients">
            <div className="section-title">
                <h2>{t('clients.title')}</h2>
                <div className="accent-line center"></div>
                <p>{t('clients.subtitle')}</p>
            </div>

            <div className="clients-grid">
                {clients.map((client, index) => (
                    <motion.div
                        key={client.id}
                        className="client-logo-wrapper"
                        initial={{ opacity: 0, scale: 0.8 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        viewport={{ once: true }}
                        transition={{ delay: index * 0.05, duration: 0.5 }}
                    >
                        <div className="client-logo">
                            {client.logo ? (
                                <img src={client.logo} alt={client.name} />
                            ) : (
                                <div className="logo-placeholder">
                                    <span>{client.name}</span>
                                </div>
                            )}
                        </div>
                    </motion.div>
                ))}
            </div>
        </Section>
    );
};

export default Clients;
